<ion-app>
  <ion-router-outlet />
  <p-toast position="bottom-right" />
</ion-app>